import { socket } from "../socket";

class SocketService {
  private currentSocketId: string | null = null;

  constructor() {
    this.initializeSocketListeners();
  }

  private initializeSocketListeners() {
    this.setupSocketListeners(socket);
  }

  private setupSocketListeners(socketInstance: any) {
    socketInstance.on("connect", () => {
      this.currentSocketId = socketInstance.id;
      console.log("Socket connected with ID:", socketInstance.id);
    });

    socketInstance.on("disconnect", () => {
      this.currentSocketId = null;
      console.log("Socket disconnected");
    });

    // If already connected, get the current ID
    if (socketInstance.connected) {
      this.currentSocketId = socketInstance.id;
    }
  }

  public getCurrentSocketId(): string | null {
    return this.currentSocketId;
  }

  public getSocket() {
    return socket;
  }

  public isConnected(): boolean {
    return socket.connected && this.currentSocketId !== null;
  }

  public getSocketIdForHeaders(): { [key: string]: string } {
    return this.currentSocketId ? { "X-Socket-ID": this.currentSocketId } : {};
  }
}

export const socketService = new SocketService();
